// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.directory {
  font-family: monospace;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 0.4em;
}

.directory .tree,
.directory .tree-node,
.directory .tree-node-group {
  list-style: none;
  margin: 0;
  padding: 0;
  margin-bottom: 1em;
}

.directory .tree-node p {
  border-bottom: solid 1px #999;
}

.directory .tree-branch-wrapper,
.directory .tree-node__leaf {
  outline: none;
  outline: none;
}

.directory .tree-node {
  cursor: pointer;
}

.directory .tree-node:hover {
  background: rgba(255, 255, 255, 0.1);
}

.directory .tree .tree-node--focused {
  background: rgba(255, 255, 255, 0.2);
}

.directory .tree .tree-node--selected {
  background: #F8F8F8;
}

.directory .tree-node__branch {
  display: block;
}

.directory .icon {
  vertical-align: middle;
  padding-right: 5px;
}

.tree-bullet {
  display: inline-block;
  margin-right: 5px;
}

.directory p {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/overview/overview.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;EAGE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX","sourcesContent":[".directory {\n  font-family: monospace;\n  user-select: none;\n  border-radius: 0.4em;\n}\n\n.directory .tree,\n.directory .tree-node,\n.directory .tree-node-group {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 1em;\n}\n\n.directory .tree-node p {\n  border-bottom: solid 1px #999;\n}\n\n.directory .tree-branch-wrapper,\n.directory .tree-node__leaf {\n  outline: none;\n  outline: none;\n}\n\n.directory .tree-node {\n  cursor: pointer;\n}\n\n.directory .tree-node:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.directory .tree .tree-node--focused {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.directory .tree .tree-node--selected {\n  background: #F8F8F8;\n}\n\n.directory .tree-node__branch {\n  display: block;\n}\n\n.directory .icon {\n  vertical-align: middle;\n  padding-right: 5px;\n}\n\n.tree-bullet {\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.directory p {\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
